// extracted by mini-css-extract-plugin
export default {"frame":"StickiesLogo_frame__xmwFQ"};